"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowALeftIcon16Solid = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var BaseIcon_1 = require("../../internal/BaseIcon");
exports.ArrowALeftIcon16Solid = forwardRef_1.forwardRef('ArrowALeftIcon16Solid', function (props, ref) {
    return (react_1.default.createElement(BaseIcon_1.BaseIcon, tslib_1.__assign({ ref: ref, viewBoxSize: 16 }, props),
        react_1.default.createElement("path", { d: "M7.68 12.038a1.25 1.25 0 0 1-1.767 1.768L1.985 9.878a2.656 2.656 0 0 1 0-3.756l3.928-3.928A1.25 1.25 0 1 1 7.68 3.962L4.892 6.75H13.5a1.25 1.25 0 0 1 0 2.5H4.892l2.788 2.788Z" })));
});
